import { Dispatch } from "redux";
import { setIsRocksLoading, setRock, setRocks, setRocksCount, setRocksSearchFields, deleteRock as removeRock, setIsDeletingRocks } from "./reducer";
import { toast } from "react-toastify";
import { IRockQueryParam, Rocks } from "models/rocks";
import constructWithOptions from "styled-components/dist/constructors/constructWithOptions";
import RocksFields from "Components/organisms/forms/rocks-form/types";

export const getRocks = (query?: IRockQueryParam) => async (dispatch: Dispatch) => {
    dispatch(setIsRocksLoading(true))
    try {
        let queryString = '';
        if (query) {
            queryString = new URLSearchParams(
                Object.entries(query).reduce((acc, [key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        acc[key] = String(value);
                    }
                    return acc;
                }, {} as Record<string, string>)
            ).toString();
        }

        const url = `${process.env.REACT_APP_API_URL}/rocks${queryString ? `?${queryString}` : ''}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();

        dispatch(setRocks(data.data.data));
        dispatch(setRocksCount(data.data.count));

    } catch (err: any) {
        toast.error(err.message ?? "Error getting rocks");
    } finally {
        dispatch(setIsRocksLoading(false))
    }
}

export const getRocksSearchFields = () => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/rocks/search-fields`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });


        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        dispatch(setRocksSearchFields(data.data));
    } catch (err: any) {
        toast.error(err.message ?? "Error getting rocks");
    }
}


export const submitRocksForm = (vals: RocksFields, handleResetForm: () => any) => async (dispatch: Dispatch, getState: any): Promise<Rocks | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/rocks`

        // Clean object
        const keys = Object.keys(vals);

        keys.forEach(k => {
            if (vals[k] === "")
                vals[k] = undefined;
        })
        const res = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        })


        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message);
        }

        const newRock = await res.json();

        const rocks = getState().Rocks.rocks;
        dispatch(setRocks([newRock.data, ...rocks]))
        handleResetForm()
        toast.success("Rock Created.")
        return newRock
    } catch (err: any) {
        toast.error(err.message ?? "Error submitting Rocks form");
        return null;
    }
}


export const editRocksForm = (vals: RocksFields, rockId: string, handleResetForm: () => any) => async (dispatch: Dispatch, getState: any): Promise<Rocks | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/rocks/${rockId}`

        // Clean object
        const keys = Object.keys(vals);

        keys.forEach(k => {
            if (vals[k] === "")
                vals[k] = undefined;
        })
        const res = await fetch(url, {
            credentials: 'include',
            method: 'PUT',
            body: JSON.stringify(vals),
            headers: {
                'Content-Type': 'application/json',
            }
        })

        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message);
        }


        const newRock = await res.json();

        const rocks: Rocks[] = getState().Rocks.rocks;

        const foundRockIndex = rocks.findIndex(r => r.id === rockId);

        if (foundRockIndex !== -1) {
            dispatch(setRock({
                rock: newRock.data,
                index: foundRockIndex
            }))
        }

        handleResetForm()
        toast.success("Rock updated.")
        return newRock
    } catch (err: any) {
        toast.error(err.message ?? "Error editing Rocks");
        return null;
    }
}


export const getRock = async (rockId: string) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/rocks/${rockId}`

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        })


        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message);
        }

        const newRock = await res.json();
        return newRock.data
    } catch (err: any) {
        toast.error(err.message ?? "Error gettting Rock");
        return null;
    }
}


export const deleteRock = (rockId: string) => async (dispatch: Dispatch): Promise<boolean> => {
    dispatch(setIsDeletingRocks(true))
    try {
        const url = `${process.env.REACT_APP_API_URL}/rocks/${rockId}`

        const res = await fetch(url, {
            credentials: 'include',
            method: 'DELETE',
        })


        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message);
        }
        dispatch(removeRock(rockId))
        dispatch(setIsDeletingRocks(false))
        toast.success("Deleted rock.");
        return true
    } catch (err: any) {
        toast.error(err.message ?? "Error deleting Rock");

        dispatch(setIsDeletingRocks(false))

        return false;
    }
}